import * as React from "react";
import { shiftDate } from "../../../../../../../utils/v3/utils/datetime.js";
import { getLastWeekDay } from "../../../../../../AvailabilityCalendar/v3/components/AvailabilityCalendar/utils.js";
const useNextWeekDate = (weeks, skip = false) => {
  return React.useMemo(() => {
    if (skip || !weeks) {
      return;
    }
    const lastWeekDay = getLastWeekDay(weeks);
    if (lastWeekDay) {
      return shiftDate(lastWeekDay, "day", 1);
    }
  }, [skip, weeks]);
};
export {
  useNextWeekDate as default,
  useNextWeekDate
};
//# sourceMappingURL=use-next-week-date.js.map
